import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	TrainingsProxy,
	scheduleTrainingListsInvalidation,
	upsertTrainingInCachedLists,
} from '@entities/training'
import { toast } from 'sonner'
import { ExerciseParams } from '@pages/TrainingConstructor/types'
import { buildWorkoutExerciseRequest } from '@entities/training/lib/helpers/buildWorkoutExerciseRequest'
import { UpdateTrainingResponse } from '@entities/training/types/create'

interface UpdateTrainingParams {
	workoutId: number
	title: string
	description: string
	exerciseParams: ExerciseParams[]
}

async function updateTrainingRequest(data: UpdateTrainingParams): Promise<UpdateTrainingResponse> {
	return TrainingsProxy.updateTraining(data.workoutId, {
		name: data.title,
		description: data.description,
		exercises: data.exerciseParams.map(buildWorkoutExerciseRequest),
	})
}

export const useUpdateTraining = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: updateTrainingRequest,
		onSuccess: updatedTraining => {
			upsertTrainingInCachedLists(queryClient, updatedTraining)
			scheduleTrainingListsInvalidation(queryClient)

			toast.success('Тренировка успешно обновлена', {
				position: 'top-right',
				duration: 3000,
			})
		},
		onError: (error: Error) => {
			const errorMessage = error.message.includes('Произошла ошибка')
				? error.message
				: 'Произошла ошибка во время обновления тренировки, пожалуйста, попробуйте обновить ее чуть позже'

			toast.error(errorMessage, {
				position: 'top-right',
				duration: 3000,
				className: 'text-red-300',
			})
		},
	})
}
